export default "__VITE_ASSET__BKQ6vEhl__"